export default "__VITE_ASSET__DBDKetjs__"